module.exports = __webpack_public_path__ + "img/whats_app.71ccd8fb.png";